//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
SPLM.SketchOperationgeometry = class{
    constructor(geometry,pointType,pointIndex,helpPoint,view){
        this.geometry=geometry;this.pointType=pointType;this.pointIndex=pointIndex;this.helpPoint=helpPoint;this.view=view;}
    get Geometry(){return this.geometry}
    set Geometry(val){this.geometry = val}
    get Pointtype(){return this.pointType}
    set Pointtype(val){this.pointType = val}
    get Pointindex(){return this.pointIndex}
    set Pointindex(val){this.pointIndex = val}
    get Helppoint(){if(this.helpPoint === undefined) this.helpPoint = new SPLM.Point3d(); return this.helpPoint}
    set Helppoint(val){this.helpPoint = val}
    get View(){return this.view}
    set View(val){this.view = val}
};

SPLM.SketchControlPoint = Object.freeze({
    "NoPoint" : "NoPoint", "StartPoint" : "StartPoint", "EndPoint" : "EndPoint", "Center" : "Center", "SplineDefiningPoint" : "SplineDefiningPoint", "Anchor" : "Anchor", "SplinePole" : "SplinePole", "MidPoint" : "MidPoint", "Quadrant" : "Quadrant", "OnCurve" : "OnCurve"});

export default SPLM;